import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useYandexMetrika, GOALS, GoalName } from './useYandexMetrika'
import { tg } from '@/constants/telegram'

// Маппинг путей к целям (без динамических ID)
const PATH_TO_GOAL_MAP: Record<string, string> = {
  '/': GOALS.PAGE_HOME,
  '/trains': GOALS.PAGE_TRAINS,
  '/train-page': GOALS.PAGE_TRAIN_DETAIL, // Без ID
  '/equipments': GOALS.PAGE_EQUIPMENTS,
  '/subscription': GOALS.PAGE_SUBSCRIPTION,
  '/subscription/': GOALS.PAGE_PURCHASE, // Без ID
  '/more': GOALS.PAGE_MORE,
  '/progress-page': GOALS.PAGE_PROGRESS,
  '/onboarding': GOALS.PAGE_ONBOARDING,
  '/way-to-goal': GOALS.PAGE_WAY_TO_GOAL,
  '/body-form': GOALS.PAGE_BODY_FORM,
  '/girl-body-form': GOALS.PAGE_GIRL_BODY_FORM,
  '/recomend-template': GOALS.PAGE_RECOMMEND_TEMPLATE, // Без ID
  '/recomend-train-page': GOALS.PAGE_RECOMMEND_TRAIN, // Без ID
  '/own-office': GOALS.PAGE_OWN_OFFICE,
  '/own-office/customers': GOALS.PAGE_OWN_OFFICE_CUSTOMERS,
  '/own-office/stats': GOALS.PAGE_OWN_OFFICE_STATS,
  '/own-office/customers/1': GOALS.PAGE_OWN_OFFICE_CLIENT,
  '/admin/': GOALS.PAGE_ADMIN,
  '/admin/users': GOALS.PAGE_ADMIN_USERS,
  '/admin/users/user': GOALS.PAGE_ADMIN_USER_DETAIL, // Без ID
  '/admin/dashboard': GOALS.PAGE_ADMIN_DASHBOARD,
}

export const usePageTracking = () => {
  const location = useLocation()
  const { trackPageView } = useYandexMetrika()

  useEffect(() => {
    // Вызываем requestFullscreen при открытии любой страницы только на мобильных устройствах
    const isMobile = tg?.platform === "ios" || tg?.platform === "android";
    const isAdminPath = window.location.pathname.startsWith("/admin");
    if (isMobile && !isAdminPath && tg?.requestFullscreen) {
      tg.requestFullscreen();
    }

    const pathWithoutId = location.pathname.replace(/\/\d+/g, '')
    
    let goalName = PATH_TO_GOAL_MAP[location.pathname]
    
    if (!goalName) {
      for (const [path, goal] of Object.entries(PATH_TO_GOAL_MAP)) {
        if (location.pathname.startsWith(path) && path !== '/') {
          goalName = goal
          break
        }
      }
    }

    if (goalName) {
      trackPageView(goalName as GoalName, {
        path: location.pathname,
        search: location.search,
        timestamp: new Date().toISOString()
      })
    }
  }, [location.pathname, location.search, trackPageView])
}
